// extracted by mini-css-extract-plugin
module.exports = {"section":"StoxWhy_section__BAC7l","imageStyles":"StoxWhy_imageStyles__1mm7K","content":"StoxWhy_content__rytiV"};